const ssn = {
    ssn : {
        value: "",
        dbqName: "form1[0].Page_1[0].SSN[0]"
     },
     docName: {
         value: "",
         dbqName: "form1[0].Page_4[0].PHYSICIANSPRINTEDNAME[0]"
     },
     docArea: {
        value: "",
        dbqName: ""
    },
     docDate: {
        value : "",
        dbqName: "form1[0].Page_4[0].Date[0]"
    },
     docNpi: {
         value : "",
         dbqName: "form1[0].Page_4[0].MEDICALLICENSENUMBER[0]"
     },
     docPhone: {
        value : "",
        dbqName: "form1[0].Page_4[0].Physiciansphoneandfaxno\\.[0]"
    },
    docAddress: {
        value : "",
        dbqName: "form1[0].Page_4[0].Address[0]"
    },
    diagnosisDate : [
        {
            type: "text",
            dbqName: "form1[0].Page_2[0].DIAGNOSIS1DIAGNOSIS1[0]",
            dateDbqName: "form1[0].Page_2[0].DateDiagnosis1[0]",
        },
        {
            type: "text",
            dbqName: "form1[0].Page_2[0].DIAGNOSIS1DIAGNOSIS2[0]",
            dateDbqName: "form1[0].Page_2[0].DateDiagnosis2[0]",
        },
        {
            type: "text",
            dbqName: "form1[0].Page_2[0].DIAGNOSIS1DIAGNOSIS3[0]",
            dateDbqName: "form1[0].Page_2[0].DateDiagnosis3[0]",
        },     
    ]

}

export default ssn ;